<template>
  <div class="success-page">
    <img :src="bgi" >
  </div>
</template>

<script>
import bgi from '../assets/success.png'
export default {
  name: 'SubmitSuccess',
  data(){
    return{
      bgi
    }
  }
}
</script>

<style lang="scss" scoped>
.success-page{
  width: 100vw;
  height: 100vh;
  background-color: rgb(223, 240, 250);
  img{
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: auto;
    z-index: 1;
  }
}
</style>